module.exports = {
	"gpio": {
		"_": {
			"label": "GPIO Options",
			"description": ""
		},
		"input_debounce": {
			"range": [
				0,
				255
			],
			"default": 10,
			"label": "Input De-bounce",
			"description": "De-bounce time in ms for all inputs"
		}
	},
	"gpio_0": {
		"_": {
			"label": "GPIO 0",
			"description": ""
		},
		"config": {
			"enum": [
				0,
				1,
				2,
				4
			],
			"default": 1,
			"label": "GPIO 0 Configuration",
			"description": "Configure GPIO 0/Module Pin 15"
		},
		"trigger": {
			"enum": [
				0,
				1,
				2,
				3
			],
			"default": 0,
			"label": "GPIO 0 Trigger",
			"description": "Trigger an event on input level change if port set as input"
		},
		"analogue_sample_rate": {
			"range": [
				0,
				255
			],
			"default": 10,
			"label": "GPIO 1 Analogue Sampling Interval",
			"description": "Time between samplings in 10ms increments"
		},
		"analogue_low_trig": {
			"range": [
				0,
				2047
			],
			"size": 2,
			"default": 0,
			"label": "GPIO 1 Analogue High trig level value",
			"description": "High trig level value"
		},
		"analogue_high_trig": {
			"range": [
				0,
				2047
			],
			"size": 2,
			"default": 2047,
			"label": "GPIO 1 Analogue Low trig level value",
			"description": "Low trig level value"
		}
	},
	"gpio_1": {
		"_": {
			"label": "GPIO 1",
			"description": ""
		},
		"config": {
			"enum": [
				0,
				1,
				2,
				4
			],
			"default": 1,
			"label": "GPIO 1 Configuration",
			"description": "Configure GPIO 1/Module Pin 16"
		},
		"trigger": {
			"enum": [
				0,
				1,
				2,
				3
			],
			"default": 0,
			"label": "GPIO 1 Trigger",
			"description": "Trigger an event on input level change if port set as input"
		},
		"analogue_sample_rate": {
			"range": [
				0,
				255
			],
			"default": 10,
			"label": "GPIO 1 Analogue Sampling Interval",
			"description": "Time between samplings in 10ms increments"
		},
		"analogue_low_trig": {
			"range": [
				0,
				2047
			],
			"size": 2,
			"default": 0,
			"label": "GPIO 1 Analogue High trig level value",
			"description": "High trig level value"
		},
		"analogue_high_trig": {
			"range": [
				0,
				2047
			],
			"size": 2,
			"default": 2047,
			"label": "GPIO 1 Analogue Low trig level value",
			"description": "Low trig level value"
		}
	},
	"gpio_2": {
		"_": {
			"label": "GPIO 2",
			"description": ""
		},
		"config": {
			"enum": [
				0,
				1,
				4
			],
			"default": 1,
			"label": "GPIO 2 Configuration",
			"description": "Configure GPIO 2/Module Pin 20"
		},
		"trigger": {
			"enum": [
				0,
				1,
				2,
				3
			],
			"default": 0,
			"label": "GPIO 2 Trigger",
			"description": "Trigger an event on input level change if port set as input"
		}
	},
	"gpio_3": {
		"_": {
			"label": "GPIO 3",
			"description": ""
		},
		"config": {
			"enum": [
				0,
				1,
				4
			],
			"default": 1,
			"label": "GPIO 3 Configuration",
			"description": "Configure GPIO 3/Module Pin 22"
		},
		"trigger": {
			"enum": [
				0,
				1,
				2,
				3
			],
			"default": 0,
			"label": "GPIO 3 Trigger",
			"description": "Trigger an event on input level change if port set as input"
		}
	},
	"gpio_4": {
		"_": {
			"label": "GPIO 4",
			"description": ""
		},
		"config": {
			"enum": [
				0,
				1,
				4
			],
			"default": 1,
			"label": "GPIO 4 Configuration",
			"description": "Configure GPIO 4/Module Pin 26"
		},
		"trigger": {
			"enum": [
				0,
				1,
				2,
				3
			],
			"default": 0,
			"label": "GPIO 4 Trigger",
			"description": "Trigger an event on input level change if port set as input"
		}
	},
	"gpio_5": {
		"_": {
			"label": "GPIO 5",
			"description": ""
		},
		"config": {
			"enum": [
				0,
				1,
				4
			],
			"default": 1,
			"label": "GPIO 5 Configuration",
			"description": "Configure GPIO 5/Module Pin 25"
		},
		"trigger": {
			"enum": [
				0,
				1,
				2,
				3
			],
			"default": 0,
			"label": "GPIO 5 Trigger",
			"description": "Trigger an event on input level change if port set as input"
		}
	},
	"gpio_6": {
		"_": {
			"label": "GPIO 6",
			"description": ""
		},
		"config": {
			"enum": [
				0,
				1,
				4
			],
			"default": 1,
			"label": "GPIO 6 Configuration",
			"description": "Configure GPIO 6/Module Pin 24"
		},
		"trigger": {
			"enum": [
				0,
				1,
				2,
				3
			],
			"default": 0,
			"label": "GPIO 6 Trigger",
			"description": "Trigger an event on input level change if port set as input"
		}
	},
	"gpio_7": {
		"_": {
			"label": "GPIO 7",
			"description": ""
		},
		"config": {
			"enum": [
				0,
				1,
				3,
				4
			],
			"default": 1,
			"label": "GPIO 7 Configuration",
			"description": "Configure GPIO 7/Module Pin 23"
		},
		"trigger": {
			"enum": [
				0,
				1,
				2,
				3
			],
			"default": 0,
			"label": "GPIO 7 Trigger",
			"description": "Trigger an event on input level change if port set as input"
		},
		"pwm_default": {
			"range": [
				0,
				100
			],
			"default": 0,
			"label": "PWM Default",
			"description": "Default PWM dutycycle at Reset"
		}
	},
	"net": {
		"_": {
			"label": "Network Options",
			"description": ""
		},
		"hiam_time": {
			"range": [
				1,
				10
			],
			"default": 1,
			"label": "HIAM Time",
			"description": "Time in seconds Time in seconds between network invites"
		},
		"max_packet_latency": {
			"range": [
				1,
				255
			],
			"default": 5,
			"label": "Max Packet Latency",
			"description": "Maximum transport time before a packet is eliminated, assumed undeliverable"
		},
		"max_jump_level": {
			"range": [
				1,
				255
			],
			"default": 20,
			"label": "Max Jump Level",
			"description": "Highest allowable network jump level"
		},
		"max_jump_count": {
			"range": [
				1,
				255
			],
			"default": 30,
			"label": "Max Jump Count",
			"description": "Maximum number of transporation jumps before a packet is elimated, assumed undeliverable"
		},
		"rssi_cc_assesment": {
			"range": [
				100,
				210
			],
			"default": 110,
			"label": "RSSI Clear Channel Assessment level",
			"description": "Max RSSI for Clear Channel during Listen Before Talk"
		},
		"connect_check_time": {
			"range": [
				4,
				20
			],
			"default": 6,
			"label": "Connect Check Time",
			"description": "Time in seconds between network evaluation"
		},
		"command_retries": {
			"range": [
				0,
				127
			],
			"default": 3,
			"label": "Command Retry",
			"description": "Retries if no response to command transmit"
		},
		"tx_retry_limit": {
			"range": [
				1,
				255
			],
			"default": 50,
			"label": "RF Transmit Retry Limit",
			"description": "Number of unsuccessful RF retries before a Router Device disconnects and attempts reconnection to the network"
		},
		"connect_change_margin": {
			"range": [
				0,
				255
			],
			"default": 12,
			"label": "Connection Change Margin",
			"description": "Minimum difference in RSSI to justify automatic change of network connection"
		},
		"command_accept_time": {
			"range": [
				0,
				255
			],
			"default": 10,
			"label": "Accept New Command Time Out",
			"description": "Minimum time before new command accepted (10ms)"
		},
		"rssi_threshold": {
			"range": [
				160,
				210
			],
			"default": 193,
			"label": "RSSI Acceptance Level",
			"description": "Minimum RSSI to accept network connection"
		},
		"excellent_rssi": {
			"range": [
				0,
				255
			],
			"default": 150,
			"ro": true,
			"label": "Excellent RSSI Level",
			"description": ""
		}
	},
	"security": {
		"_": {
			"label": "Security Options",
			"description": ""
		},
		"level": {
			"enum": [
				0,
				1,
				2
			],
			"label": "Security Level",
			"description": "Select Encryption mode"
		}
	},
	"device": {
		"_": {
			"label": "Device Options",
			"description": ""
		},
		"command_ack": {
			"enum": [
				0,
				1
			],
			"default": 1,
			"label": "Command Acknowledge",
			"description": "Enable command acknowledge from destination device"
		},
		"part": {
			"ro": true,
			"size": 12,
			"default": "RC1XXX-TM",
			"label": "PART Number",
			"description": ""
		},
		"fw_revision": {
			"size": 5,
			"ro": true,
			"default": "1.00",
			"label": "HW Revision",
			"description": ""
		},
		"hw_revision": {
			"size": 5,
			"ro": true,
			"default": "2.00",
			"label": "FW Revision",
			"description": ""
		},
		"detect_busy_network": {
			"enum": [
				0,
				1,
				2
			],
			"default": 0,
			"label": "Detect Network Busy",
			"description": "Gateway action when network activity detect after Reset"
		},
		"protocol_mode": {
			"enum": [
				0,
				1
			],
			"default": 1,
			"label": "Protocol Mode",
			"description": "Packet format selection"
		},
		"locator": {
			"enum": [
				0,
				1
			],
			"default": 0,
			"label": "Locator",
			"description": "Enable Locator function"
		},
		"type": {
			"enum": [
				1,
				2
			],
			"default": 2,
			"label": "Device Type",
			"description": ""
		},
		"sid": {
			"range": [
				0,
				4294967295
			],
			"size": 4,
			"type": "address",
			"default": 1,
			"label": "System ID",
			"description": ""
		},
		"uid": {
			"range": [
				0,
				4294967295
			],
			"size": 4,
			"type": "address",
			"ro": true,
			"label": "Unique ID",
			"description": ""
		}
	},
	"cluster": {
		"_": {
			"label": "Cluster Detection Options",
			"description": ""
		},
		"rssi_threshold": {
			"range": [
				40,
				100
			],
			"default": 60,
			"label": "Clustered Node RSSI",
			"description": "RSSI level to  form a node cluster"
		},
		"device_limit": {
			"range": [
				5,
				100
			],
			"default": 10,
			"label": "Clustered Node Device Limit",
			"description": "Minimum number of densely located nodes required to be defined as a cluster"
		}
	},
	"rf_jamming": {
		"_": {
			"label": "RF Jamming Options",
			"description": ""
		},
		"port": {
			"enum": [
				0,
				1,
				2,
				3,
				4,
				5,
				6,
				7
			],
			"default": 3,
			"label": "RF Jamming Alarm Port",
			"description": "The selected GPIO will go LOW on alaram status, and will remain LOW for as long as alarm status is present. Note: Selected GPIO must be configured for High Output"
		},
		"detect": {
			"range": [
				0,
				100
			],
			"default": 0,
			"label": "RF Jamming Detect",
			"description": "Minimum time in minutes of continuous radio jamming on all radio channels before and RF Jamming alarm is generated"
		}
	},
	"rf": {
		"_": {
			"label": "RF Options",
			"description": ""
		},
		"channel": {
			"range": [
				1,
				83
			],
			"default": 4,
			"label": "RF Channel",
			"description": "RF Channel"
		},
		"mac_rnd_mask_1": {
			"enum": [
				116,
				63,
				31,
				15,
				7,
				3
			],
			"default": 127,
			"label": "MAC RndTime1Mask",
			"description": "Radio State 1 max. delay mask. First TX"
		},
		"mac_rnd_mask_2": {
			"enum": [
				116,
				63,
				31,
				15,
				7,
				3
			],
			"default": 15,
			"label": "MAC RndTime2Mask",
			"description": "Radio State 1 max. delay mask. repeat TX"
		},
		"power": {
			"range": [
				1,
				5
			],
			"default": 5,
			"label": "RF Power",
			"description": "RF Output Power"
		},
		"data_rate": {
			"range": [
				1,
				6
			],
			"default": 5,
			"label": "RF Data rate",
			"description": "RF Data rate"
		}
	},
	"uart": {
		"_": {
			"label": "UART Options",
			"description": ""
		},
		"cts_hold_time": {
			"range": [
				1,
				255
			],
			"default": 60,
			"label": "CTS Hold time",
			"description": "CTS hold time in 10ms increments"
		},
		"timeout": {
			"range": [
				1,
				255
			],
			"default": 20,
			"label": "",
			"description": "Time out in periods of 1ms between character inputs on serial port, before a packet is transmitted in Transparent mode"
		},
		"stop_bits": {
			"enum": [
				1,
				2
			],
			"default": 1,
			"label": "UART Stop Bits",
			"description": "Number of stop  bits"
		},
		"bits": {
			"enum": [
				8,
				9
			],
			"default": 8,
			"label": "UART Bits",
			"description": "UART word size"
		},
		"flow_control": {
			"range": [
				1,
				59
			],
			"default": 1,
			"label": "UART Flow Control",
			"description": "Reference SERIAL PORT HANDSHAKE"
		},
		"parity": {
			"enum": [
				0,
				1
			],
			"default": 0,
			"label": "UART Parity",
			"description": "0 = Parity Disable"
		},
		"buffer_margin": {
			"range": [
				0,
				100
			],
			"default": 18,
			"label": "Serial Buffer Full Margin",
			"description": "Number of bytes left in Serial Buffer when CTS goes false and/or Xoff transmitted"
		},
		"baud_rate": {
			"enum": [
				1,
				2,
				3,
				4,
				5,
				6,
				7,
				8,
				9,
				10,
				11
			],
			"default": 5,
			"label": "UART Baud Rate",
			"description": "Baud Rate"
		}
	},
	"ima": {
		"_": {
			"label": "I'm Alive (IMA) Options",
			"description": ""
		},
		"time": {
			"range": [
				1,
				255
			],
			"default": 255,
			"label": "IMA Time",
			"description": "Time in minutes between automatic status messages"
		},
		"on_connect": {
			"enum": [
				0,
				1
			],
			"default": 0,
			"label": "IMA On Connect",
			"description": "nable automatic IMA message on Network connection"
		},
		"time_base": {
			"range": [
				1,
				255
			],
			"default": 6,
			"label": "IMA time base",
			"description": "Time Base for IMA Timer and End-Device wake-up, in periods of 10 seconds"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./lib/bundle/dashboard/device/configuration/def/default.json
// module id = 539
// module chunks = 0